import request from './api'

/**
 * 根据交易单号查询订单溯源报告
 * @param {String} tradeNo 交易单号
 * @returns {Promise}
 */
export function getOrdersByTradeNoWithTraceReport(tradeNo) {
  return request({
    url: `/nxdepartmentorders/getOrdersByTradeNoWithTraceReport/${tradeNo}`,
    method: 'get'
  })
}

